import React from 'react';
import CouponIcon from "../../assets/images/Offer.svg";
import RemoveCouponIcon from "../../assets/images/ebookIcon.svg";
import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    expired: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& p': {
            fontSize: 12,
            margin: 0,
            color: '#4F4F4F',
            flex: 1,
            fontWeight: 700,
            '&.green': {
                color: '#40B90E',
                textAlign: 'right',
                fontWeight: 700,
            }
        }
    },
    applyCouponBlock: {
        background: '#F7F5FF',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
        '& span': {
            display: 'flex',
            alignItems: 'center',
            fontSize: 12,
            color: '#747575',
            '& img': {
                width: 16,
                marginRight: 6
            }
        },
        '& p': {
            margin: 0,
            color: '#008C74',
            fontWeight: 'bold',
            fontSize: 14,
            cursor: 'pointer'
        }
    },
    discountedPrice: {
        color: '#757575',
        fontWeight: 400,
        fontSize: 13,
        position: 'relative',
        marginRight: 5,
        '&::before': {
            content: `''`,
            position: 'absolute',
            zIndex: 1,
            background: '#757575',
            height: 2,
            width: '100%',
            top: 6
        }
    },
    selectedPackage: {
        padding: '30px 14px',
        '& h4': {
            fontSize: 16,
            color: '#000',
            margin: 0,
            marginBottom: 5,
        },
        '& p': {
            fontSize: 13,
            '& span.dots': {
                width: 4,
                height: 4,
                display: 'inline-block',
                background: '#4F4F4F',
                verticalAlign: 2,
                margin: '0 2px',
                borderRadius: '50%',
            }
        },
        '@media (max-width: 767px)': {
            marginLeft: -14,
            marginRight: -14,
            border: '0px solid #F8F8F8',
        }
    },
    paymentBlock: {
        '@media (max-width: 767px)': {
            width: 'calc(100% + 28px)',
            marginRight: -14,
            marginLeft: -14,
        },
    },
    payNowBtn: {
        borderRadius: 0,
        width: '100%',
        backgroundColor: '#008C74',
        color: '#fff',
        fontSize: 16,
        fontWeight: 700,
        textTransform: 'uppercase',
        position: 'fixed',
        bottom: 0,
        zIndex: 9999,
        left: 0,
        right: 0,
        padding: '12px 0',
        '&:hover': {
            backgroundColor: '#008C74',
        },
        '@media (min-width: 1025px)': {
            position: 'static',
            width: 'auto',
            display: 'flex',
            margin: '60px auto 0',
            padding: '12px 70px',
            borderRadius: 4
        }
    },
    days: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 10,
        '& h4': {
            margin: 0
        },
    },
    removeCoupon: {
        textDecoration: 'underline'
    }
}));
const PlanConfirmationView = props => {
    const classes = useStyles();
    const {
        selectedPlan,
        getDays,
        handleOpen,
        selectedCoupon,
        removeCoupon,
        paymentAction
    } = props;

    function payNow() {
        window.location.replace(paymentAction);
    }

    return (
        <>
            <div className={classes.selectedPackage}>
                <div className={classes.days}>
                    <h4>{selectedPlan.name}</h4>
                    <h4 className="rightAlign">
                        <span
                            className={classes.discountedPrice}>₹{selectedPlan.actualPrice}
                        </span> ₹{selectedPlan.finalPrice}
                    </h4>
                </div>
                <div className={classes.expired}>
                    <h4>Valid for {getDays(selectedPlan.subscriptionType)} Days</h4>
                    <p className="green">You
                        Save <span>₹{selectedPlan.cashDiscount.toFixed(2)} ({selectedPlan.discount}%)</span>
                    </p>
                </div>
            </div>
            {
                !(selectedCoupon && selectedCoupon.couponCode) ?
                    <div className={`${classes.applyCouponBlock} ${classes.paymentBlock}`}>
                                <span>
                                    <img src={CouponIcon} alt=""/>
                                    Get exciting offers inside
                                </span>
                        <p onClick={handleOpen}>Apply Coupon</p>
                    </div> : <div className={`${classes.applyCouponBlock} ${classes.paymentBlock}`}>
                                <span>
                                    <img src={RemoveCouponIcon} alt=""/>
                                    {selectedCoupon.couponCode} (Coupon applied)
                                </span>
                        <p className={classes.removeCoupon} onClick={removeCoupon}>Remove</p>
                    </div>
            }
            <Button className={classes.payNowBtn} onClick={payNow}> PAY NOW</Button>
        </>
    );
};

export default PlanConfirmationView;
